import { ReactNode, useCallback } from "react";

import { useToast } from "@chakra-ui/react";

import { Box, Flex, SafeHtmlRenderer } from "components";
import { MdClose } from "react-icons/md";

export interface ICustomToastProps {
  message: ReactNode;
  isClosable?: boolean;
}

export const useCustomToast = (): (({
  message,
  isClosable,
}: ICustomToastProps) => void) => {
  const toast = useToast();

  return useCallback(
    ({ message, isClosable = true }: ICustomToastProps) => {
      toast({
        duration: 5000,
        isClosable,
        position: "bottom",
        variant: "solid",
        containerStyle: {
          width: "100%",
          maxWidth: "lg",
        },
        render: ({ onClose }) => (
          <Flex
            color="white"
            borderRadius="md"
            fontSize="14px"
            fontFamily="Inter"
            fontWeight="400"
            p="14px"
            bg="#1B1B1B"
            boxShadow="lg"
            justifyContent="space-between"
            alignItems="center"
            margin="0 16px "
          >
            <Box>
              {typeof message === "string" ? (
                <SafeHtmlRenderer html={message} />
              ) : (
                message
              )}
            </Box>
            {isClosable && (
              <Box cursor="pointer" onClick={onClose}>
                <MdClose />
              </Box>
            )}
          </Flex>
        ),
      });
    },
    [toast],
  );
};
